import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { Client } from '@core/services/client/client.model';
import { ClientService } from '@core/services/client/client.service';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { inputNoWhitespaceValidator } from '@shared/directives/input-no-whitespace.directive';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'Teranet-ClientInfo',
  templateUrl: './client-info.component.html'
})
export class ClientInfoComponent implements OnInit {
  @Input() ClientInfoId: number;
  @Input() Readonly: boolean;
  @Output() getTitleChangeEvent = new EventEmitter<string>();
  change: EventEmitter<number> = new EventEmitter<number>();
  client: Client;
  clientFormGroup: FormGroup;
  clientTypes: any;

  constructor(
    private authService: AuthService,
    private clientService: ClientService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
  ) {
    this.clientFormGroup = new FormGroup({
      corporationCode: new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
      corporationName: new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
      corporationType: new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
      isEnabled: new FormControl(true)
    });
    this.clientTypes = ['Lender','Insurer'];
  
  }

  ngOnInit() {
    this.clientService.setTitleChanged('Add Client');

    

    this.refesh();
  }

  

  createClient() {
    if (this.clientFormGroup.valid) {

      const newClient: Client = {
        corporationcode: this.clientFormGroup.get('corporationCode').value,
        corporationname: this.clientFormGroup.get('corporationName').value,
        corporationtype: this.clientFormGroup.get('corporationType').value,
        id: this.ClientInfoId >= 0 ? this.ClientInfoId : -1,
        isdeleted: false,
        isenabled: this.clientFormGroup.get('isEnabled').value,
        isinsert: false,
        clientfileinfomodel:[]
      };

      if (this.ClientInfoId >= 0) {
        this.clientService.updateClient(newClient).subscribe(value => {
          if (value) {
            this.client = value as Client;
            this.clientService.setTitleChanged('Manage Client | ' + this.client.corporationname);
            return;
          }
        });
      } else {
        this.clientService.createClient(newClient).subscribe(value => {
          if (value) {
            this.client = value as Client;
            this.ClientInfoId = value.id as number;
            this.clientService.setClientChanged(this.ClientInfoId);
            this.clientService.setTitleChanged('Manage Client | ' + this.client.corporationname);
            return;
          }
        });
      }
    } else {
      this.toastrService.error(`Client ${this.clientFormGroup.get('corporationName').value} has validation error(s). Please check each section in the Client tab.`,
        'Validation Error');
    }
  }

  goToClient() {
    this.router.navigateByUrl('/clientinfo');
  }

  isReadOnly() {
    if (this.Readonly || this.ClientInfoId == 0) {
      this.clientFormGroup.disable();
    } else {
      this.clientFormGroup.enable();
    }
  }

  isRequired(value: string): Boolean {
    if (value == 'CG') {
      if (this.clientFormGroup.get('isCGClient').value) return true;
    } else if (value == 'CGE') {
      if (this.clientFormGroup.get('isCGEClient').value) return true;
    } else if (value == 'REPO') {
      if (this.clientFormGroup.get('isRepoEnabled').value) return true;
    } else if (value == 'RO') {
      if (this.clientFormGroup.get('isROEnabled').value) return true;
    }
    return false;
  }

  refesh() {
    this.spinner.show();
    this.route.queryParams.subscribe(value => {
      if (value) {
        if (value['id'] as number >= 0) {
          this.ClientInfoId = value['id'] as number;
        }
        else {
          this.ClientInfoId = -1;
        }
      }
    });
    if (this.ClientInfoId >= 0) {
      this.clientService.getClientInfoById(this.ClientInfoId).subscribe(value => {
        if (value) {
          this.client = value as Client;
          this.clientFormGroup.patchValue({ ...this.client });
          this.clientService.setTitleChanged('Manage Client | ' + this.client.corporationname);
          this.isReadOnly();
          this.spinner.hide();
          return;
        }
      });
    }
    else {
      this.spinner.hide();
    }
  }

  toggleCGClientState(event) {
    var cgClientName = this.clientFormGroup.get('cgClientName');
    var cgeClientName = this.clientFormGroup.get('cgeClientName');
    if (event) {
      cgClientName.enable();
      this.clientFormGroup.get('isCGEClient').setValue(false);
      cgeClientName.setValue('');
      cgeClientName.disable();
    } else {
      cgClientName.disable();
      cgClientName.setValue('');
    }
  }

  toggleCGeClientState(event) {
    var cgClientName = this.clientFormGroup.get('cgClientName');
    var cgeClientName = this.clientFormGroup.get('cgeClientName');

    if (event) {
      cgeClientName.enable();
      this.clientFormGroup.get('isCGClient').setValue(false);
      cgClientName.setValue('');
      cgClientName.disable();
    } else {
      cgeClientName.disable();
      cgeClientName.setValue('');
    }
  }

  toggleInputStateByCheckbox(event, inputControlName) {
    var inputControl = this.clientFormGroup.get(inputControlName);
    if (inputControl) {
      if (event) {
        inputControl.enable();
      } else {
        inputControl.disable();
      }
    }
  }
}
